var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('button',{staticClass:"btn btn-info btn-icon mw",on:{"click":_vm.sendRequest}},[_vm._v("\n    "+_vm._s(_vm._f("setText")("create_query","Сформировать заявку"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }